module.exports = __webpack_public_path__ + "static/media/leftGrey.06019a63.svg";